import nbsp from 'nbsp'

export default (text) =>
  nbsp(text, { min: 1, max: 1, words: ['za'], removeWidows: true })



// WEBPACK FOOTER //
// ./src/assets/js/nbsp.js